import { cn, zoneInfo, zoneTitle } from '@/shared/lib'
import { Icon } from '@/shared/ui/icon'

// Подпись зоны организации в шапке. Моменты продукт показывает по часам того,
// кто смотрит, и объявлять их зону незачем — она и так его. А вот сутки и сроки
// считаются в зоне организации, одной на всех, и её человеку знать надо: без
// подписи «срок 17:00» читается по своим часам, а это другое время.
//
// Расхождение с зоной устройства помечается точкой и объясняется в title —
// ненавязчиво: это не ошибка, а факт, который стоит знать тому, кто не в офисе.
export function ZoneBadge({ className }: { className?: string }) {
  const zone = zoneInfo()
  // Тот же текст, что в title у срока (`ZoneTag kind="org"`, `DueDate`): подпись
  // зоны обязана звучать одинаково, где бы её ни спросили.
  const title = zoneTitle()
  return (
    <span
      title={title}
      className={cn(
        'hidden items-center gap-1.5 rounded-control px-2 py-1 font-mono text-xs text-text-tertiary sm:inline-flex',
        className,
      )}
    >
      <Icon name="clock" size={14} aria-hidden />
      {zone.label}
      {zone.mismatch && (
        <>
          <span className="size-1.5 rounded-pill bg-warning" aria-hidden />
          {/* Точку скринридер не увидит — расхождение проговаривается текстом. */}
          <span className="sr-only">{title}</span>
        </>
      )}
    </span>
  )
}
